import React, { useState, useEffect, useId } from 'react';
import * as apiClient from "../../services/apiClient";
import './Home.css';
import { Row, Col } from "react-flexbox-grid";


const Home = () => {
    const [translations, setTranslations] = useState([]);

    useEffect(() => {
        const LoadPage = async () => {
            const language = navigator.language.startsWith('es') ? 'es' : 'en';
            const labels = await apiClient.GetLabelsByFolderAndControllerAndLabelName(language, "PermisosAplicaciones", "Home", "home");

            const data = await apiClient.GetTranslationsByLabels(language, labels);
            setTranslations(data);
        };

        LoadPage();
    }, []);

    const getTranslation = (label) => {
        const translation = translations.find((t) => t.label === label);
        return translation ? translation.body : '';
    };

    return (
        <Row>
            <Col xs={12} className='text-center'>
                <img src='/dist/img/home.png' className='HomeImagen mt-2'/>
            </Col>
        </Row>
    );
}

export default Home;